import "./style.css";
import { DatasViewItems } from "../../components/datas/DatasViewItems";

export function DatasView() {
  return (
    <div id="datas" className="datas_div">
      <div className="datas_items_title">
        <div className="datas_items_div">
          <img src="./img/sjbt.png" />
        </div>
      </div>
      <div className="datas_items">
        <DatasViewItems />
      </div>
    </div>
  );
}
